import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_b067eaumjh: FaireBrandEntity = {
  token: "b_b067eaumjh",
  type: "brand",
  name: "Happy French Gang",
  avatarUrl:
    "https://cdn.faire.com/fastly/a1f7fa273eae8d1974e00c5874ab5d9f251547554e1254056931c1280ec780ea.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/21a3e461378d1a3dc8529436110f6d497b15070b34e2d36dc55d558e74d10e0e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a1f7fa273eae8d1974e00c5874ab5d9f251547554e1254056931c1280ec780ea.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/21a3e461378d1a3dc8529436110f6d497b15070b34e2d36dc55d558e74d10e0e.jpeg",
  location: "SAN FRANCISCO, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 34,
  isTopShop: true,
  isInsider: true,
  description:
    "Happy French Gang is a sustainable textile company with apparel and home décor collections. All the textiles are hand-spun, hand-woven, hand-dyed and hand-stitched with an organic cotton. It is a one woman owned company and is a combination of a French vision and a California creation. HFG works with a small indian cooperative and knows all the artisans involved in the process. \nOur best sellers are our iconic jumpsuits.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:57:48.339Z",
    importedBy: "entity-db-cli",
  },
};
